<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-dark.text-white
				span.fa.fa-info.mr-2
				| Datos del contrato
			.card-body(v-if="!contrato")
				.row
					.col
						.form-group
							label Selecciona el contrato
							input-query(
								input-class="form-control"
								placeholder="Busca el contrato"
								:realtime="true"
								url="radiacion/php/api/buscar-contrato.php"
								@selected="seleccionaContrato($event)"
							)
			.card-body.bg-light(v-else)
				.row
					.col
						b Agente
						br
						| {{contrato.AgenteNombre}}
					.col
						b Cliente
						br
						| {{contrato.ClienteNombre}}
					.col
						b Título
						br
						| {{contrato.Titulo}}
					.col
						b Importe
						br
						| {{contrato.ImporteTotal | currency('')}} €
		div(v-if="radiacion")
			MenuOriginales(:linea="lineaSeleccionada", @accion="ver = $event")
			.table-responsive
				table.table.table-condensed
					thead
						tr
							th(rowspan="2") Línea
							th.text-center(rowspan="2") Tot
							th.text-center(rowspan="2") Mes
							th.text-center.dia(v-for="dia in dias", :key="dia.getTime()") {{dia | moment('dd')}}
						tr 
							th.dia(v-for="dia in dias", :key="dia.getTime()") {{dia.getDate()}}
					tbody
						tr(
							v-for="linea in radiacion.lineas"
							v-if="linea.ArticuloID"
							:class="(lineaSeleccionada && lineaSeleccionada.LineaID === linea.LineaID) ? 'lineaSeleccionada' : ''"
						)
							td(
								style="cursor: pointer"
								@click="seleccionaLinea(linea)"
							)
								.desglose
									div.bold
										span.badge.badge-danger.mr-2(style="font-size:1em;")
											span(v-if="/^\d+$/.test(linea.LineaID)") {{linea.LineaID}}
											span(v-else) Nueva
										span.ml-2 {{linea.Concepto}}
										span.badge.ml-2(:class="linea.inserciones.length < linea.Cantidad ? 'badge-warning' : linea.inserciones.length > linea.Cantidad ? 'badge-danger' : 'badge-success'") {{linea.inserciones.length}}/{{linea.Cantidad}} inserciones
									template(v-if="desgloseLinea && desgloseLinea.ficheros.length > 0 && desgloseLinea.linea.LineaID === linea.LineaID")
										div(
											v-for="fichero in desgloseLinea.ficheros"
											:key="fichero.FicheroID"
										) {{fichero.FicheroID}} - {{fichero.Descripcion}}
							td.text-center
								.desglose
									div.bold {{getTotalLinea(linea)}}
									template(v-if="desgloseLinea && desgloseLinea.ficheros.length > 0 && desgloseLinea.linea.LineaID === linea.LineaID")
										div(
											v-for="fichero in desgloseLinea.ficheros"
											:key="fichero.FicheroID"
										) {{ getTotalFichero(fichero) }}
							td.text-center
								.desglose
									div.bold {{getInsercionesMes(linea)}}
									template(v-if="desgloseLinea && desgloseLinea.ficheros.length > 0 && desgloseLinea.linea.LineaID === linea.LineaID")
										div(
											v-for="fichero in desgloseLinea.ficheros"
											:key="fichero.FicheroID"
										) {{ getInsercionesMesFichero(fichero) }}
							td.dia(
								v-for="dia in dias",
								:key="linea.LineaID + '-' + dia.getTime()",
								:class="(dia < radiacion.FechaInicio || dia > radiacion.FechaFin) ? 'dia-inactivo' : 'dia-activo'"
								@click="verDetallesDia(linea, dia)"
							)
								.desglose.text-center
									div.bold(v-html="insercionesDia(linea.LineaID, dia)")
									template(v-if="desgloseLinea && desgloseLinea.ficheros.length > 0 && desgloseLinea.linea.LineaID === linea.LineaID")
										div(
											v-for="fichero in desgloseLinea.ficheros"
											:key="fichero.FicheroID"
											v-html="insercionesDiaFichero(fichero, dia)"
										)
						tr
							td.text-center &nbsp;
							td.text-center {{ totalInserciones }}
							td.text-center {{ totalInsercionesMes }}
							td.text-center.dia(
								v-for="dia in dias",
								:key="'TotDia -' + dia.getTime()",
								:class="(dia < radiacion.FechaInicio || dia > radiacion.FechaFin) ? 'dia-inactivo' : 'dia-activo'"
								v-html="insercionesDia(null, dia)"
							)

			nav.mt-3
				ul.pagination
					li.page-item(v-for="mes in meses", :key="mes.getTime()", :class="(mesActivo === mes) ? 'active' : ''", @click="mesActivo = mes")
						a.page-link
							span {{nombreMes[mes.getMonth()]}}
							span(v-if="variosAnos") , {{mes.getFullYear()}}
			p
				.btn-group
					button.btn.btn-danger(@click="deshacer()", v-if="historialModificaciones.length > 0 && punteroHistorial > 0") Deshacer
					button.btn.btn-danger(@click="rehacer()", v-if="historialModificaciones.length - 1 > punteroHistorial") Rehacer
			colocacion(:EmisoraID="lineaSeleccionada.EmisoraID", v-if="lineaSeleccionada && ver === 'colocacion'", @cerrar="ver = ''", @colocacion="setColocacion($event)")
			InsertarOriginales(v-if="ver === 'insertarOriginales'", :linea="lineaSeleccionada", :contrato="contrato", @cerrar="ver = ''", @inserciones="setInserciones($event)")
			EliminarInserciones(v-if="ver === 'eliminarInserciones'", :contrato="contrato", :radiacion="radiacion", @cerrar="ver = ''", @eliminar="eliminarInserciones($event)", @anular="anularInserciones($event)")
			RecuperarInserciones(v-if="ver === 'recuperarInserciones'", :contrato="contrato", :radiacion="radiacion", @cerrar="ver = ''", @recuperar="recuperarInserciones($event)")
			DetallesDia(v-if="diaSeleccionado", :bloques="bloques", :linea="diaSeleccionado.linea", :contrato="contrato", :dia="diaSeleccionado.dia", @cerrar="cerrarDetallesDia", @guardar="guardarInsercionesDia($event)")
			CopiarInserciones(v-if="ver === 'copiarInserciones'", :contrato="contrato", :linea="lineaSeleccionada", @cerrar="ver = ''", @guardar="reemplazaInserciones($event)")
			RotacionVertical(v-if="ver === 'rotacionVertical'", :contrato="contrato", :linea="lineaSeleccionada", @cerrar="ver = ''", @rotacion="reemplazaInserciones($event)")
</template>

<script>
import MenuOriginales from './menu'
import Services from '../../servicios.js'
import Colocacion from './colocacion/colocacion.vue'
import InsertarOriginales from './insertar-originales/insertar-originales.vue'
import EliminarInserciones from './eliminar/eliminar-inserciones'
import RecuperarInserciones from './recuperar/recuperar-inserciones.vue'
import DetallesDia from './detalles-dia/detalles-dia'
import CopiarInserciones from './copiar-inserciones/copiar-inserciones.vue'
import RotacionVertical from './rotacion-vertical/rotacion-vertical'
export default {
	props: ['RadiacionID'],
	components: {
		colocacion: Colocacion,
		InsertarOriginales,
		EliminarInserciones,
		RecuperarInserciones,
		MenuOriginales,
		DetallesDia,
		CopiarInserciones,
		RotacionVertical
	},
	data () {
		return {
			contrato: null,
			nombreMes: [
				'Enero',
				'Febrero',
				'Marzo',
				'Abril',
				'Mayo',
				'Junio',
				'Julio',
				'Agosto',
				'Septiempre',
				'Octubre',
				'Noviembre',
				'Diciembre'
			],
			lineaSeleccionada: null,
			diaSeleccionado: null,
			radiacion: null,
			ver: '',
			mesActivo: null,
			bloques: new Map(),
			historialModificaciones: [],
			punteroHistorial: null
		}
	},
	created () {
		if (this.RadiacionID) {
			// TODO: Obtener la radiación
		}
		this.mesActivo = this.meses[0]
	},
	computed: {
		dias () {
			if (!this.mesActivo) {
				return []
			}

			const mes = new Date(this.mesActivo.getTime())
			const mesNum = mes.getMonth()
			mes.setDate(1)
			mes.setHours(0)
			mes.setMinutes(0)
			mes.setSeconds(0)
			mes.setMilliseconds(0)

			const dias = []
			while (mesNum === mes.getMonth()) {
				dias.push(new Date(mes.getTime()))
				mes.setDate(mes.getDate() + 1)
			}

			return dias
		},
		meses () {
			if (!this.contrato) {
				return []
			}
			const arr = []

			let mes = new Date(this.contrato.FechaInicio)
			mes.setDate(1)

			while (mes.getTime() <= this.contrato.FechaFin) {
				arr.push(new Date(mes.getTime()))
				mes.setMonth(mes.getMonth() + 1)
			}

			return arr
		},

		variosAnos () {
			return (
				this.meses[0].getFullYear() !==
				this.meses[this.meses.length - 1].getFullYear()
			)
		},

		totalInserciones () {
			return this.radiacion.lineas.reduce((acc, linea) => {
				if (linea.inserciones) {
					const total = linea.inserciones.reduce((cant, ins) => {
						if (!ins.Anulada) {
							cant = cant + ins.Inserciones
						}
						return cant
					}, 0)
					acc = acc + total
				}
				return acc
			}, 0)
		},

		totalInsercionesMes () {
			return this.radiacion.lineas.reduce((acc, linea) => {
				acc = acc + this.getInsercionesMes(linea)
				return acc
			}, 0)
		},

		desgloseLinea () {
			if (!this.lineaSeleccionada) {
				console.log('No hay linea seleccionada')
				console.log(this.lineaSeleccionada)
				return null
			}

			// Desglosamos por ficheros
			const ficheros = this.lineaSeleccionada.inserciones.reduce((acc, ins) => {
				if (!acc.has(ins.FicheroID)) {
					acc.set(ins.FicheroID, {
						FicheroID: ins.FicheroID,
						Descripcion: ins.Descripcion,
						inserciones: [ins]
					})
				} else {
					const i = acc.get(ins.FicheroID)
					i.inserciones.push(ins)
					acc.set(ins.FicheroID, i)
				}
				return acc
			}, new Map())

			return {
				linea: this.lineaSeleccionada,
				ficheros: Array.from(ficheros).map(l => l[1])
			}
		}
	},

	methods: {
		seleccionaContrato (ev) {
			ev.datos.lineas = []
			this.contrato = ev.datos
			this.getLineas()
		},
		getLineas () {
			if (!this.contrato) {
				return
			}

			Services.GetLineasContrato(this.contrato.ContratoID)
				.then(lineas => {
					this.contrato.lineas = lineas
					this.mesActivo = this.meses[0]
					this.generarRadiacion()
				})
				.catch(e => {
					this.$error('Error', e)
				})
		},
		getBloques () {
			const form = {
				EmisoraID: this.contrato.lineas.reduce((acc, linea) => {
					if (acc.indexOf(linea.CatalogoID) < 0) {
						acc.push(linea.CatalogoID)
					}
					return acc
				}, []),
				DiaInicio: this.$moment(this.contrato.FechaInicio).format('YYYY-MM-DD'),
				DiaFin: this.$moment(this.contrato.FechaFin).format('YYYY-MM-DD'),
				RadiacionID: this.radiacion.RadiacionID
			}
			Services.GetBloques(form)
				.then(bloques => {
					this.bloques = bloques.reduce((acc, bloque) => {
						bloque.DuracionInsercionesNuevas = 0
						bloque.LineasInserciones = []
						acc.set(bloque.BloqueID, bloque)
						return acc
					}, new Map())
					// this.seleccionarBloquesInserciones()
				})
				.catch(e => {
					console.error(e)
					this.$error('Error', e)
				})
		},
		generarRadiacion () {
			this.radiacion = {
				RadiacionID: null,
				ContratoID: this.contrato.ContratoID,
				ContratoOriginal: this.contrato.ContratoOriginal,
				UsuarioID: null,
				FechaInicio: this.contrato.FechaInicio,
				FechaFin: this.contrato.FechaFin,
				FechaCreacion: new Date(),
				FechaModificacion: null,
				FechaEliminado: null,
				Comentarios: null,
				lineas: this.contrato.lineas.map(l => {
					const linea = {
						LineaID: 'L-' + new Date().getTime().toString() + '' + Math.round(Math.random() * 1000),
						ArticuloID: l.ArticuloID,
						LineaContratoID: l.LineaID,
						RadiacionID: null,
						EmisoraID: l.CatalogoID,
						EmisoraNombre: l.CatalogoNombre,
						Concepto: l.Concepto,
						ImporteNeto: l.ImporteNeto,
						ImporteBruto: l.ImporteBruto,
						ImporteTotal: l.ImporteTotal,
						ImporteUnitario: l.ImporteUnitario,
						Cantidad: l.Cantidad,
						Descuento: l.Descuento,
						TipoColocacion: null,
						ProgramaID: null,
						ContenidoID: null,
						HoraInicio: null,
						HoraFin: null,
						Fijacion: null,
						originales: [],
						inserciones: []
					}
					return linea
				})
			}

			this.guardarHistorial()
			this.getBloques()
			this.$forceUpdate()
		},
		guardarHistorial () {
			if (this.punteroHistorial !== null) {
				this.historialModificaciones.splice(this.punteroHistorial + 1)
			}
			this.historialModificaciones.push({
				radiacion: JSON.parse(JSON.stringify(this.radiacion)),
				lineaSeleccionada: JSON.parse(JSON.stringify(this.lineaSeleccionada))
			})
			this.punteroHistorial = this.historialModificaciones.length - 1
		},
		cargarHistorial () {
			this.radiacion = this.historialModificaciones[this.punteroHistorial].radiacion
			this.lineaSeleccionada = this.historialModificaciones[this.punteroHistorial].lineaSeleccionada
		},
		deshacer () {
			if (this.punteroHistorial === null) {
				this.punteroHistorial = this.historialModificaciones.length - 1
				if (this.punteroHistorial < 0) {
					this.punteroHistorial = null
					return
				}
			}
			this.punteroHistorial = this.punteroHistorial - 1
			this.cargarHistorial()
		},
		rehacer () {
			if (this.punteroHistorial === null) {
				return
			}
			this.punteroHistorial = this.punteroHistorial + 1
			if (this.punteroHistorial >= this.historialModificaciones.length) {
				this.punteroHistorial = this.historialModificaciones.length - 1
			}
			this.cargarHistorial()
		},
		verDetallesDia (linea, dia) {
			this.diaSeleccionado = {
				dia: this.$moment(dia).format('YYYY-MM-DD'),
				linea: linea
			}
		},
		guardarInsercionesDia ($event) {
			// Lo primero es borrar las inserciones del día
			for (let i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.diaSeleccionado.linea.LineaID) {
					console.log('Linea encontrada')
					this.radiacion.lineas[i].inserciones = this.radiacion.lineas[i].inserciones.filter(i => i.Dia !== this.diaSeleccionado.dia)
					this.radiacion.lineas[i].inserciones = this.radiacion.lineas[i].inserciones.concat($event)
				}
			}
			this.cerrarDetallesDia()
			this.seleccionarBloquesInserciones()
		},
		cerrarDetallesDia () {
			this.diaSeleccionado = null
		},
		setColocacion (colocacion) {
			this.lineaSeleccionada.ProgramaID = colocacion.ProgramaID
			this.lineaSeleccionada = {...this.lineaSeleccionada, ...colocacion}

			for (let i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					this.radiacion.lineas[i] = this.lineaSeleccionada
				}
			}
			this.guardarHistorial()
		},
		reemplazaInserciones (inserciones) {
			for (let l = 0; l < this.radiacion.lineas.length; l++) {
				if (this.radiacion.lineas[l].LineaID === this.lineaSeleccionada.LineaID) {
					this.radiacion.lineas[l].inserciones = inserciones
				}
			}
			try {
				this.seleccionarBloquesInserciones()
			} catch (e) {
				console.error(e)
			}
		},
		setInserciones (inserciones) {
			for (let l = 0; l < this.radiacion.lineas.length; l++) {
				if (this.radiacion.lineas[l].LineaID === this.lineaSeleccionada.LineaID) {
					for (let i = 0; i < inserciones.length; i++) {
						const dia = new Date(inserciones[i].DiaUnix)
						dia.setHours(0)
						dia.setMinutes(0)
						dia.setSeconds(0)
						dia.setMilliseconds(0)

						const diaFin = new Date(inserciones[i].DiaUnix)
						diaFin.setHours(23)
						diaFin.setMinutes(59)
						diaFin.setSeconds(59)
						diaFin.setMilliseconds(999)
						if (dia > this.radiacion.FechaInicio && diaFin < this.radiacion.FechaFin) {
							this.radiacion.lineas[l].inserciones.push(inserciones[i])
						}
					}
					this.radiacion.lineas[l].originales = []
				}
			}
			// this.lineaSeleccionada = null
			try {
				this.seleccionarBloquesInserciones()
			} catch (e) {
				console.error(e)
			}
		},
		eliminarInserciones (dias) {
			let indice = null
			dias = dias.map(d => this.$moment(d).format('YYYY-MM-DD'))
			for (let i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					indice = i
				}
			}

			if (indice === null) {
				return
			}

			this.radiacion.lineas[indice].inserciones = this.radiacion.lineas[indice].inserciones.filter(i => {
				return (dias.indexOf(i.Dia) < 0)
			})
			this.seleccionarBloquesInserciones()
		},
		anularInserciones (dias) {
			let indice = null
			dias = dias.map(d => this.$moment(d).format('YYYY-MM-DD'))
			for (let i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					indice = i
				}
			}

			if (indice === null) {
				return
			}

			this.radiacion.lineas[indice].inserciones = this.radiacion.lineas[indice].inserciones.map(i => {
				if (dias.indexOf(i.Dia) >= 0) {
					i.Anulada = true
				}
				return i
			})
			this.seleccionarBloquesInserciones()
		},
		recuperarInserciones (dias) {
			let indice = null
			dias = dias.map(d => this.$moment(d).format('YYYY-MM-DD'))
			for (let i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					indice = i
				}
			}

			if (indice === null) {
				return
			}

			this.radiacion.lineas[indice].inserciones = this.radiacion.lineas[indice].inserciones.map(i => {
				if (dias.indexOf(i.Dia) >= 0) {
					i.Anulada = false
				}
				return i
			})
			this.seleccionarBloquesInserciones()
		},
		getInsercionesMes (linea) {
			const mesStr = this.$moment(this.mesActivo).format('YYYY-MM')

			return linea.inserciones.reduce((acc, ins) => {
				const mesLinea = this.$moment(ins.DiaUnix).format('YYYY-MM')
				if (mesLinea === mesStr && !ins.Anulada) {
					acc = acc + ins.Inserciones
				}
				return acc
			}, 0)
		},
		getInsercionesMesFichero (fichero) {
			const mesStr = this.$moment(this.mesActivo).format('YYYY-MM')

			return fichero.inserciones.reduce((acc, ins) => {
				const mesLinea = this.$moment(ins.DiaUnix).format('YYYY-MM')
				if (mesLinea === mesStr && !ins.Anulada) {
					acc = acc + ins.Inserciones
				}
				return acc
			}, 0)
		},
		getTotalLinea (linea) {
			if (!linea.inserciones) {
				return 0
			}
			return linea.inserciones.reduce((acc, ins) => {
				acc = (ins.Anulada) ? acc : acc + ins.Inserciones
				return acc
			}, 0)
		},
		getTotalFichero (fichero) {
			return fichero.inserciones.reduce((acc, ins) => {
				acc = (ins.Anulada) ? acc : acc + ins.Inserciones
				return acc
			}, 0)
		},
		insercionesDia (LineaID, dia) {
			if (!this.radiacion || !this.radiacion.lineas || !Array.isArray(this.radiacion.lineas)) {
				return null
			}
			let sinBloque = 0
			const inserciones = this.radiacion.lineas.reduce((acc, linea) => {
				if ((LineaID && linea.LineaID === LineaID && linea.inserciones && Array.isArray(linea.inserciones)) || !LineaID) {
					const diaStr = this.$moment(dia).format('YYYY-MM-DD')
					acc = linea.inserciones.reduce((acc, insercion) => {
						if (diaStr === insercion.Dia) {
							if (insercion.Anulada) {
								acc = false
							}
							acc = (acc === false) ? false : acc + insercion.Inserciones

							if (insercion.Inserciones !== insercion.Bloques.length) {
								sinBloque = sinBloque + insercion.Inserciones - insercion.Bloques.length
							}
						}

						return acc
					}, acc)
				}
				return acc
			}, 0)

			if (inserciones === false) {
				return '<span class="fa fa-ban text-danger"></span>'
			} else if (inserciones === 0) {
				return '<span>&nbsp;</span>'
			} else {
				if (sinBloque > 0) {
					return `<span class="text-warning" style="text-decoration:underline;">${inserciones}</span>`
				} else {
					return `<span>${inserciones}</span>`
				}
			}
		},
		insercionesDiaFichero (fichero, dia) {
			let sinBloque = 0
			const diaStr = this.$moment(dia).format('YYYY-MM-DD')
			const inserciones = fichero.inserciones.reduce((acc, insercion) => {
				if (diaStr === insercion.Dia) {
					if (insercion.Anulada) {
						acc = false
					}
					acc = (acc === false) ? false : acc + insercion.Inserciones

					if (insercion.Inserciones !== insercion.Bloques.length) {
						sinBloque = sinBloque + insercion.Inserciones - insercion.Bloques.length
					}
				}
				return acc
			}, 0)

			if (inserciones === false) {
				return '<span class="fa fa-ban text-danger"></span>'
			} else if (inserciones === 0) {
				return '<span>&nbsp;</span>'
			} else {
				if (sinBloque > 0) {
					return `<span class="text-warning" style="text-decoration:underline;">${inserciones}</span>`
				} else {
					return `<span>${inserciones}</span>`
				}
			}
		},
		seleccionaLinea (linea) {
			this.lineaSeleccionada = linea
		},
		seleccionarBloquesInserciones () {
			console.log('-------------------------------------------------------')
			console.log('-------------------------------------------------------')
			console.log('-------------------------------------------------------')
			console.log('------------------ RECALCULANDO -----------------------')
			console.log('-------------------------------------------------------')
			console.log('-------------------------------------------------------')
			console.log('-------------------------------------------------------')
			// Reseteamos los bloques
			this.bloques = Array.from(this.bloques).reduce((acc, b) => {
				b[1].DuracionInsercionesNuevas = 0
				b[1].LineasInserciones = []
				acc.set(b[1].BloqueID, b[1])
				return acc
			}, new Map())
			for (let l = 0; l < this.radiacion.lineas.length; l++) {
				const linea = this.radiacion.lineas[l]

				for (let i = 0; i < linea.inserciones.length; i++) {
					const insercion = linea.inserciones[i]
					const horaInicio = this.$moment(insercion.Dia + ' ' + insercion.HoraInicio).unix()
					const horaFin = this.$moment(insercion.Dia + ' ' + insercion.HoraFin).unix()

					// Reseteamos el bloque
					this.radiacion.lineas[l].inserciones[i].BloqueID = null

					// Ahora buscamos un bloque adecuado
					let bloquesCompatibles = []
					const bloques = Array.from(this.bloques).map(b => b[1])
					for (let b = 0; b < bloques.length; b++) {
						const bloque = bloques[b]
						if (bloque.EmisoraID === linea.EmisoraID && bloque.Dia === insercion.Dia) {
							// Vemos si está en el rango horario que queremos
							if (horaInicio <= bloque.UnixTime && horaFin >= bloque.UnixTime) {
								bloquesCompatibles.push(bloque)
							}
						}
					}

					if (bloquesCompatibles.length === 0) {
						continue
					}

					this.radiacion.lineas[l].inserciones[i].Bloques = []

					// TODO: Ordenar los bloques en función del tiempo libre que quede en cada uno de ellos

					for (let j = 0; j < insercion.Inserciones; j++) {
						/*
							TODO: Ordenar los bloques compatibles por:
								- Nº Inserciones (de este original) de menos a mayor
								- % de ocupación del bloque (de menor a mayor)
								- Hora de inicio del bloque (de menor a mayor)
						*/
						// Actualizamos la información de los bloques compatibles
						bloquesCompatibles = bloquesCompatibles.map(b => {
							b = this.bloques.get(b.BloqueID)
							return b
						})

						bloquesCompatibles.sort((a, b) => {
							const insercionesA = a.LineasInserciones.reduce((acc, linea) => {
								if (linea.InsercionID === insercion.InsercionID) {
									acc = acc + 1
								}
							}, 0)

							const insercionesB = b.LineasInserciones.reduce((acc, linea) => {
								if (linea.InsercionID === insercion.InsercionID) {
									acc = acc + 1
								}
							}, 0)
							const duracionA = a.DuracionInserciones + a.DuracionInsercionesNuevas
							const duracionB = b.DuracionInserciones + b.DuracionInsercionesNuevas
							const completoA = duracionA * 100 / a.Duracion
							const completoB = duracionB * 100 / b.Duracion

							if (insercionesA > insercionesB) {
								return 1
							} else if (insercionesA < insercionesB) {
								return -1
							} else {
								if (completoA > completoB) {
									return 1
								} else if (completoB > completoA) {
									return -1
								} else {
									if (a.HoraInicioUnix > b.HoraInicioUnix) {
										return 1
									} else if (a.HoraInicioUnix < b.HoraInicioUnix) {
										return -1
									} else {
										return 0
									}
								}
							}
						})
						// const indiceBloque = bloquesCompatibles.length < j + 1 ? j % bloquesCompatibles.length : j
						const indiceBloque = 0
						const bloque = bloquesCompatibles[indiceBloque]

						let pos
						switch (insercion.Fijar) {
						case 'Primera':
							pos = 0
							break
						case 'Segunda':
							pos = 1
							break
						case 'Mitad':
							pos = Math.floor(bloque.Inserciones / 2)
							break
						case 'Penultima':
							pos = bloque.Inserciones - 2
							break
						case 'Ultima':
							pos = bloque.Inserciones - 1
							break
						default:
							pos = null
							break
						}
						this.radiacion.lineas[l].inserciones[i].Bloques.push({
							BloqueID: bloquesCompatibles[indiceBloque].BloqueID,
							HoraInicio: bloquesCompatibles[indiceBloque].HoraInicio,
							Duracion: bloquesCompatibles[indiceBloque].Duracion,
							DuracionInserciones: bloquesCompatibles[indiceBloque].DuracionInserciones,
							Posicion: pos
						})

						const b = this.bloques.get(bloquesCompatibles[indiceBloque].BloqueID)
						b.DuracionInsercionesNuevas = b.DuracionInsercionesNuevas + this.radiacion.lineas[l].inserciones[i].DuracionReal
						b.LineasInserciones.push(this.radiacion.lineas[l].inserciones[i])
						this.bloques.set(bloquesCompatibles[indiceBloque].BloqueID, b)
					}
				}
			}

			this.guardarHistorial()
		}
	}
}
</script>

<style scoped>
.radiacion {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  /* align-items: stretch; */
  align-content: stretch;
  width: 100%;
  border: 1px solid #666666;
  border-bottom: 0;
  background-color: white;
}
.radiacion:last-of-type {
  border-bottom: 1px solid #666666;
}
.radiacion > div {
  flex: 1 auto;
  align-self: auto;
  border-right: 1px solid #666666;
  border-left: none;
  height: 30px;
  line-height: 30px;
  text-overflow: ellipsis;
}
.radiacion > div:last-child {
  border-right: none;
}
.radiacion > div:first-child {
  padding-left: 10px;
  min-width: 100px;
  flex-shrink: 0;
}

.radiacion > div.dia {
  max-width: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  text-overflow: ellipsis;
}
thead, tbody, tr {
	border: 0;
}
th, td {
	border: 1px solid #e0e0e0;
	border-bottom: 0;
	padding: 0;
}

th {
	background-color: #8888aa;
	color: white;
}
td {
	background-color: white;
}

td:first-of-type {
	min-width: 400px;
}

th.dia {
	max-width: 30px;
	width: 30px;
	height: 30px;
	text-align: center;
	vertical-align: middle;
}

.lineaSeleccionada > td:first-of-type {
	background-color: orange !important;
	color: black;
}

.dia-inactivo {
  background-color: #bbbbbb;
}

.dia-activo {
  background-color: white !important;
}

.desglose {
	margin-top: 5px;
	display: flex;
	position: relative;
	flex-direction: column;
	width: 100%;
}

.desglose > div {
	padding: 5px;
	border-top: 1px solid #e0e0e0;
	opacity: 0.7;
}

.desglose > div:first-of-type {
	border-top: 0;
}

.bold {
	font-weight: bold;
	opacity: 1 !important;
}
/* .desglose > div:nth-child(2) {
	background-color: rgba(255, 255, 255, 0.5);
} */
</style>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/radiacion.vue